<!--
 * @Description 合同详情-采购单tab
-->
<template>
  <div
    v-loading="loading"
    v-empty="nopermission"
    class="rc-cont"
    xs-empty-icon="nopermission"
    xs-empty-text="暂无权限">
    <el-table
      v-show="fieldList.length > 0"
      :data="list"
      :height="tableHeight"
      :cell-class-name="cellClassName"
      stripe>
      <el-table-column
        v-for="(item, index) in fieldList"
        :key="index"
        :prop="item.prop"
        :label="item.label"
        :width="item.width"
        :fixed="item.fixed"
        show-overflow-tooltip>
        <template slot-scope="{ row, column }">
          <template v-if="item.prop === 'number'">
						<div>
              <div class="ellipsis">
                <span>{{ row.number }}</span>
                <span 
                  class="ml-8"
                  :style="{color: '#2441B3', cursor: 'pointer'}"
                  v-clipboard:copy="`${row.number}`"
                  v-clipboard:success="clipboardSuccess"
                >
                  <IconSvg name="iconic_copy" class="fn-14 pointer"/>
                </span>
              </div>
            </div>
					</template>
          <template v-else-if="item.prop === 'spotName'">
						<div>
              <div class="ellipsis"  :style="{color: '#2441B3', cursor: 'pointer'}" @click="jumpSpotDetail(row.spotId)">{{ row.spotName === row.placeName ? row.spotName : `${row.placeName}-${row.spotName}` }}</div>
            </div>
					</template>
          <template v-else-if="item.prop === 'displayDates'">
            {{ Array.isArray(row.displayDates) && row.displayDates.length ? row.displayDates.join(',') : '-'  }}
					</template>
          <template v-else-if="item.prop === 'purchaseFee'">
						<div>
              <div>{{ row.purchaseFee ? beautifyThePrice(row.purchaseFee, ',', 2, '¥') : '-'}} 
                <el-tooltip effect="dark" placement="top" trigger="hover">
                  <div slot="content">
                    <div v-if="row.placeFee">场地成本：{{ row.placeFee? beautifyThePrice(row.placeFee, ',', 2, '¥') : '-' }}</div>
                    <div v-if="row.intermediaryPlaceFee">场地成本（撮合）：{{ row.intermediaryPlaceFee? beautifyThePrice(row.intermediaryPlaceFee, ',', 2, '¥') : '-' }}</div>
                    <div 
                      v-for="(item,index) in row.priceDetail" :key="index">
                        {{item.name }}：{{ item.value? beautifyThePrice(item.value, ',', 2, '¥') : '-' }}</div>
                        <div>特殊报批：{{ row.payableSpecialApprovalFee? beautifyThePrice(row.payableSpecialApprovalFee, ',', 2, '¥') : '-' }}</div>
                        <div>他项：{{ row.payableOtherFee? beautifyThePrice(row.payableOtherFee, ',', 2, '¥') : '-' }}</div>
                    </div>
                    <IconSvg name="iconjy_ic_shuomingfuhao_normal" class="fn-14 pointer"/>
                </el-tooltip>
              </div>
            </div>
					</template>
          <template v-else-if="item.prop === 'depositFee'">
						<div>
              <div>{{ row.depositFee ? beautifyThePrice(row.depositFee, ',', 2, '¥') : '-'}} 
              </div>
            </div>
					</template>
          <template v-else-if="item.prop === 'roleRelationList'">
						<div v-if="Array.isArray(row.roles) && row.roles.length">
              <div class="ellipsis" v-for="(item,index) in row.roles" :key="index">
                {{ item.name }}：{{ Array.isArray(item.employees) && item.employees.length?item.employees.map(item=>item.name).join('、') : '-' }}
              </div>
            </div>
            <div v-else>
              -
            </div>
					</template>
          <template v-else-if="item.prop === 'mark'">
           <div v-if="row.mark">{{ row.mark }}</div>
           <div v-else>-</div>

					</template>
          <template v-else-if="item.prop === 'status'">
            <span :style="getStatusStyle(row.status)" class="status-mark" />
            <span>{{ row.statusName }}</span>
					</template>
          <template v-else-if="item.prop === 'permissions'">
            <span 
              v-if="Array.isArray(row.permissions) && row.permissions.length?row.permissions.filter(item=>item.event === 'purchaseOrder:detail').length : false"
              :style="{color: '#2441B3', cursor: 'pointer'}"
              @click="jumpPurchaseDetail(row.id)">详情</span>
					</template>
					<template v-else>
						{{ row[item.prop] }}
					</template>
				</template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script type="text/javascript">

import { crmContractQueryPurchaseAPI } from '@/api/crm/contract'
import { beautifyThePrice } from '@lhb/func'
import clipboard from '@/directives/clipboard/index.js'; // use clipboard by v-directive

export default {
  name: 'ContractPurchase', // 采购单相关
  components: {
  },
  directives: {
    clipboard
  },
  mixins: [],
  props: {
    id: [String, Number],
    detail: {
      type: Object,
      default: ()=>({})
    }
  },
  data() {
    return {
      loading: false,
      nopermission: false,
      list: [],
      fieldList: [],
      tableHeight: '400px',
      beautifyThePrice,
      statusMap: new Map([
        [2, 'warning'],
        [3, 'warning'],
        [4, 'processing'],
        [5, 'success'],
        [6, 'error'],
        [7, 'default']
      ])
    }
  },
  computed: {
    
  },
  watch: {
  },
  mounted() {
    this.getDetail()
  },
  methods: {
    /**
     * 复制地址
     */
     clipboardSuccess() {
      this.$message.success('复制成功');
    },
    getStatusStyle(status) {
      const type = this.statusMap.get(status);
      if(type === 'default') {
        return {background: 'rgba(149, 155, 171, 1)'}
      } else if(type === 'success') {
        return {background: 'rgba(82, 196, 26, 1)'}
      } else if(type === 'warning') {
        return {background: 'rgba(255, 134, 29, 1)'}
      } else if(type === 'error') {
        return {background: 'rgba(255, 77, 79, 1)'}
      } else if(type === 'processing') {
        return {background: 'rgba(0, 57, 194, 1)'}
      }
    },
    jumpPurchaseDetail(id) {
      window.open(`/lhb-micro-pms/purchase/detail?id=${id}`, '_blank');
    },
    jumpSpotDetail(id) {
      window.open(`/lhb-micro-pms/pointMng/detail?tenantSpotId=${id}`, '_blank');
    },

    /**
     * 表头数据
     */
    getFieldList() {
      this.fieldList.push({ prop: 'number', label: '采购单号', width: 250 })
      this.fieldList.push({ prop: 'supplyName', label: '供应商名', width: 180 })
      this.fieldList.push({ prop: 'spotName', label: '场地点位', width: 200 })
      this.fieldList.push({ prop: 'title', label: '活动名称', width: 220 })
      this.fieldList.push({ prop: 'displayDates', label: '活动时间', width: 120 })
      this.fieldList.push({ prop: 'purchaseFee', label: '场地成本', width: 180 })
      this.fieldList.push({ prop: 'depositFee', label: '押金', width: 180 })
      this.fieldList.push({ prop: 'roleRelationList', label: '跟进人', width: 150 })
      this.fieldList.push({ prop: 'mark', label: '备注', width: 200 })
      this.fieldList.push({ prop: 'status', label: '当前状态', width: 80 })
      this.fieldList.push({ prop: 'permissions', label: '操作', width: 120, fixed:'right' })
    },

    /**
     * 获取数据
     */
    getDetail(loading = true) {
      if (this.fieldList.length == 0) {
        this.getFieldList()
      }
      this.loading = loading
      crmContractQueryPurchaseAPI({id: this.id, contractKeyword: this.detail.num, page: 1, size: 999}).then((res) => {
        const { objectList = [] } = res;
        this.list = objectList || [];
        this.loading = false;
      })
    },

    /**
     * 通过回调控制class
     */
    cellClassName({ row, column, rowIndex, columnIndex }) {
      if (column.property === 'num') {
        return 'can-visit--underline'
      } else {
        return ''
      }
    },
  }
}
</script>
<style lang="scss" scoped>
@import "../../styles/relativecrm.scss";
@import "../../styles/table.scss";

.tips {
  color: #909399;
  width: 100%;
  text-align: right;
  margin-top: 10px;
}

</style>

